<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="skills"
      :table-select="false"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="技能编号">
            <el-input v-model.trim="filter.skillNo" placeholder="请输入技能编号" clearable />
          </el-form-item>
          <el-form-item label="技能名称">
            <el-input v-model.trim="filter.skillName" placeholder="请输入技能名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <SkillEdit ref="SkillEdit" @save-success="loadData"></SkillEdit>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import SkillEdit from "./SkillEdit";
export default {
  components: { viewTable, SkillEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(729),
        editAuth: this.$auth(733),
        delAuth: this.$auth(734),
      },
      filter: {},
      columnsProperty: [
        {
          tooltip: true,
          key: "skillNo",
          width: 100,
          align: "center",
        },
        {
          key: "skillName",
          minWidth: 150,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "creatorName",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "createTime",
          width: 160,
          align: "center",
        },
        {
          key: "action",
          align: "center",
          width: 140,
          slot: "action",
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    // 新增、编辑
    addEditHandle(row) {
      this.$refs.SkillEdit.open(row);
    },

    // 加载数据
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },

    // 删除
    deleteHandle(row) {
      this.$http.delete("basic", "skills", row.pkid).then((resp) => {
        if (resp.success) {
          this.loadData();
          this.$message.success("删除成功");
        }
      });
    },

    resetHandle(filter) {
      this.filter = filter;
    },
  },
};
</script>
